import React from 'react';
import { Col } from 'antd';
import { TrainingFormItem } from '@/components/views/Resolution886/components/Form';

export function Training(): JSX.Element {
	return (
		<Col xs={24}>
			<TrainingFormItem fieldName="training" required={false} />
		</Col>
	);
}
